import config from '../config.json';

const RedirectToLogin = () => {
  window.location.replace(`${config.saml.loginUrl}`);
};

export default RedirectToLogin;
